import { history, useLocation, useRequest } from '@umijs/max';
import { Flex, Tag } from 'antd';
import React from 'react';
import { YesNoStatus } from '@/constants/yesNo';
import { TagBizType } from '@/pages/system/tag/constants';
import tagService from '@/services/tag';

const { CheckableTag } = Tag;
const TAG_ID_PARAM = 'tagId';
const LEGACY_TAG_IDS_PARAM = 'tagIds';

export const parseTagId = (search: string) => {
  const searchParams = new URLSearchParams(search);
  const value =
    searchParams.get(TAG_ID_PARAM) ??
    searchParams.get(LEGACY_TAG_IDS_PARAM)?.split(',').find(Boolean);
  const tagId = Number(value);
  return Number.isInteger(tagId) && tagId > 0 ? tagId : undefined;
};

const APP_TAGS_CACHE_KEY = 'tag-list-app';

const AppTagNav: React.FC = () => {
  const location = useLocation();
  const selectedTagId = parseTagId(location.search);
  const { data: tags = [] } = useRequest(
    () => tagService.listTags({ bizType: TagBizType.App, status: YesNoStatus.Enabled }),
    { cacheKey: APP_TAGS_CACHE_KEY },
  );

  const updateTagId = (nextTagId?: number) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete(LEGACY_TAG_IDS_PARAM);
    if (nextTagId) {
      searchParams.set(TAG_ID_PARAM, String(nextTagId));
    } else {
      searchParams.delete(TAG_ID_PARAM);
    }
    const qs = searchParams.toString();
    history.replace({ pathname: location.pathname, search: qs ? `?${qs}` : '' });
  };

  return (
    <div className="app-tag-nav">
      <div className="app-tag-nav-inner">
        <Flex gap={8} wrap="wrap" className="app-tag-nav-list">
          <CheckableTag
            className={`app-tag-nav-tag${!selectedTagId ? ' app-tag-nav-tag-checked' : ''}`}
            checked={!selectedTagId}
            onChange={() => updateTagId(undefined)}
          >
            全部
          </CheckableTag>
          {tags.map((tag) => {
            const checked = selectedTagId === tag.id;
            return (
              <CheckableTag
                key={tag.id}
                className={`app-tag-nav-tag${checked ? ' app-tag-nav-tag-checked' : ''}`}
                checked={checked}
                style={{ '--app-tag-color': tag.color || '#1677ff' } as React.CSSProperties}
                onChange={(next) => updateTagId(next ? (tag.id as number) : undefined)}
              >
                {tag.name}
              </CheckableTag>
            );
          })}
        </Flex>
      </div>
    </div>
  );
};

export default AppTagNav;
